import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "icon"]

  connect() {
    // Set up ARIA attributes
    if (this.hasButtonTarget && this.hasContentTarget) {
      // Ensure content has an ID for aria-controls
      if (!this.contentTarget.id) {
        this.contentTarget.id = `toggle-content-${Math.random().toString(36).substr(2, 9)}`
      }

      this.buttonTarget.setAttribute("aria-controls", this.contentTarget.id)
      this.buttonTarget.setAttribute("aria-expanded", !this.contentTarget.classList.contains("hidden"))
    }
  }

  toggle() {
    const isHidden = this.contentTarget.classList.contains("hidden")
    this.contentTarget.classList.toggle("hidden")

    // Update ARIA state
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", isHidden)
    }

    // Rotate icon if present
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }

  // Allow keyboard activation
  keydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.toggle()
    }
  }
}
